import { render, staticRenderFns } from "./ViewComplaints.vue?vue&type=template&id=c89c1744&scoped=true"
import script from "./ViewComplaints.vue?vue&type=script&lang=js"
export * from "./ViewComplaints.vue?vue&type=script&lang=js"
import style0 from "./ViewComplaints.vue?vue&type=style&index=0&id=c89c1744&prod&scoped=true&lang=css"
import style1 from "./ViewComplaints.vue?vue&type=style&index=1&id=c89c1744&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c89c1744",
  null
  
)

export default component.exports